import * as Icons from '@ant-design/icons';
import { Card, Flex, InputNumber, Switch, Tag, Tooltip } from 'antd';
import { DealIconComponent } from 'assets/icons/deal';
import { DiscountCampaign } from './GeneralRule';
import { DiscountCreatePayload } from '../../../interfaces/discount';
import { HttpError, useTable } from '@refinedev/core';
import { IProduct } from 'interfaces/products';
import { PageHeader } from 'components/professor_area/PageHeader';
import { RenderManyDiscounts } from './components/RenderManyDiscounts';
import { ResumeManyDiscount } from './components/ResumeManyDiscounts';
import { ResumeManyDiscountForm } from './components/ResumeManyDiscountForm';
import { SetDiscountRuleType } from './components/SetDiscountRuleType';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { Stack } from '@qcx/ui';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

export const CreateManyProductDealForm = ({
  product,
  resourceType,
  discounts
}: {
  discounts: DiscountCampaign[];
  product: IProduct;
  resourceType: 'product_id' | 'invoice_due';
}) => {
  const [invoiceRule, setInvoiceRule] = useState(false);
  const [productRule, setProductRule] = useState(true);

  const [productCreateData, setproductCreateData] =
    useState<DiscountCreatePayload>({});
  const [invoiceDueCreateData, setInvoiceDueCreateData] =
    useState<DiscountCreatePayload>({});

  const [discountPercentage, setDiscountPercentage] = useState<number>(1);
  const [discountPercentageInvoice, setDiscountPercentageInvoice] =
    useState<number>(1);
  const [invoiceDueAmount, setInvoiceDueAmount] = useState<number>(2);

  useEffect(() => {
    setproductCreateData(
      productRule
        ? {
            products: [{ id: product.id, name: product.name }],
            discount_type: 'percentage',
            discount_value: discountPercentage
          }
        : {}
    );

    setInvoiceDueCreateData(
      invoiceRule
        ? {
            products: [{ id: product.id, name: product.name }],
            discount_type: 'percentage',
            discount_value: discountPercentageInvoice,
            invoice_due: invoiceDueAmount
          }
        : {}
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountPercentage, invoiceDueAmount, discountPercentageInvoice]);

  return (
    <Card>
      <Stack css={{ w: '$full', gap: '$10' }}>
        <div className="w-full">
          <Stack>
            <div className="border rounded border-solid divide-y border-[#EAECF0] w-full">
              <Stack
                css={{
                  p: '$4',
                  d: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                {resourceType === 'invoice_due' ? (
                  <>
                    <p className="flex items-center gap-2 m-0 font-semibold text-sm leading-6 text-[rgba(0,0,0,0.85)]">
                      <span>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.99935 5.00002V10L13.3327 11.6667M18.3327 10C18.3327 14.6024 14.6017 18.3334 9.99935 18.3334C5.39698 18.3334 1.66602 14.6024 1.66602 10C1.66602 5.39765 5.39698 1.66669 9.99935 1.66669C14.6017 1.66669 18.3327 5.39765 18.3327 10Z"
                            stroke="black"
                            strokeOpacity="0.85"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      Inadimplência maior que
                      <InputNumber
                        size="large"
                        name="inoice_value"
                        className="max-w-[130px]"
                        addonAfter="dias"
                        min={31}
                        onChange={value => setInvoiceDueAmount(value)}
                        value={invoiceRule ? invoiceDueAmount : undefined}
                        disabled={!invoiceRule}
                      />
                      <Tooltip title="Esse é o desconto aplicado em toda a prateleira. Podendo ser sobrescrito pelo desconto por produto.">
                        <Icons.QuestionCircleOutlined />
                      </Tooltip>
                    </p>
                    <Stack
                      css={{
                        d: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        w: 'fit-content',
                        gap: '$3'
                      }}
                    >
                      <InputNumber
                        size="large"
                        name="invoice_discount_value"
                        className="max-w-[100px]"
                        addonAfter="%"
                        min={1}
                        max={99}
                        onChange={value => setDiscountPercentageInvoice(value)}
                        value={
                          invoiceRule ? discountPercentageInvoice : undefined
                        }
                        disabled={!invoiceRule}
                      />
                      <Switch
                        value={invoiceRule}
                        onChange={value => {
                          setInvoiceRule(value);
                        }}
                      />
                    </Stack>
                  </>
                ) : (
                  <>
                    <p className="flex items-center gap-2 m-0 font-semibold text-sm leading-6 text-[rgba(0,0,0,0.85)]">
                      <span>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_3137_35623)">
                            <path
                              d="M7.49935 7.50008H7.50768M12.4994 12.5001H12.5077M13.3327 6.66675L6.66602 13.3334M14.917 4.1655C15.0886 4.58053 15.418 4.91041 15.8327 5.08264L17.287 5.68506C17.7021 5.85698 18.0318 6.18674 18.2037 6.6018C18.3757 7.01685 18.3757 7.4832 18.2037 7.89826L17.6018 9.35158C17.4298 9.76682 17.4296 10.2336 17.6023 10.6487L18.2032 12.1016C18.2885 12.3071 18.3324 12.5275 18.3324 12.75C18.3324 12.9726 18.2886 13.1929 18.2035 13.3985C18.1183 13.6041 17.9935 13.7909 17.8361 13.9483C17.6787 14.1056 17.4919 14.2304 17.2863 14.3155L15.833 14.9175C15.418 15.0891 15.0881 15.4185 14.9159 15.8332L14.3135 17.2876C14.1416 17.7027 13.8118 18.0324 13.3968 18.2043C12.9817 18.3763 12.5154 18.3763 12.1004 18.2043L10.6471 17.6023C10.232 17.4308 9.76587 17.4312 9.35108 17.6033L7.89676 18.2049C7.48195 18.3764 7.01602 18.3763 6.60132 18.2045C6.18662 18.0327 5.85706 17.7033 5.68503 17.2887L5.08245 15.8339C4.91085 15.4189 4.58147 15.089 4.16672 14.9168L2.7124 14.3143C2.29754 14.1425 1.9679 13.813 1.79592 13.3981C1.62394 12.9833 1.62371 12.5172 1.79527 12.1022L2.39724 10.6489C2.56873 10.2338 2.56838 9.76762 2.39626 9.35282L1.79516 7.8974C1.70993 7.69183 1.66605 7.47148 1.66602 7.24894C1.66598 7.0264 1.70979 6.80604 1.79495 6.60044C1.88011 6.39484 2.00494 6.20804 2.16232 6.05071C2.3197 5.89338 2.50654 5.7686 2.71215 5.6835L4.16543 5.08151C4.58007 4.91006 4.90975 4.58108 5.0821 4.1668L5.6845 2.71242C5.85642 2.29737 6.18616 1.96761 6.6012 1.79569C7.01624 1.62377 7.48257 1.62377 7.89761 1.79569L9.35089 2.39768C9.76594 2.56918 10.2321 2.56882 10.6469 2.3967L12.1018 1.79662C12.5168 1.6248 12.983 1.62483 13.398 1.79672C13.813 1.96861 14.1427 2.29827 14.3146 2.71322L14.9172 4.16802L14.917 4.1655ZM7.91602 7.50008C7.91602 7.7302 7.72947 7.91675 7.49935 7.91675C7.26923 7.91675 7.08268 7.7302 7.08268 7.50008C7.08268 7.26996 7.26923 7.08341 7.49935 7.08341C7.72947 7.08341 7.91602 7.26996 7.91602 7.50008ZM12.916 12.5001C12.916 12.7302 12.7295 12.9167 12.4994 12.9167C12.2692 12.9167 12.0827 12.7302 12.0827 12.5001C12.0827 12.27 12.2692 12.0834 12.4994 12.0834C12.7295 12.0834 12.916 12.27 12.916 12.5001Z"
                              stroke="black"
                              strokeOpacity="0.85"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_3137_35623">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      Valor Base
                      <Tooltip title="Esse é o desconto aplicado em toda a prateleira. Podendo ser sobrescrito pelo desconto por produto.">
                        <Icons.QuestionCircleOutlined />
                      </Tooltip>
                    </p>
                    <Stack
                      css={{
                        d: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        w: 'fit-content',
                        gap: '$3'
                      }}
                    >
                      <InputNumber
                        size="large"
                        name="value"
                        className="max-w-[100px]"
                        addonAfter="%"
                        min={1}
                        max={99}
                        onChange={value => setDiscountPercentage(value)}
                        value={productRule ? discountPercentage : undefined}
                        disabled={!productRule}
                      />
                      <Switch
                        value={productRule}
                        onChange={value => {
                          setProductRule(value);
                        }}
                      />
                    </Stack>
                  </>
                )}
              </Stack>
            </div>
          </Stack>
        </div>
        <Stack flow="column" css={{ w: '$full', maxW: 400, gap: '$5' }}>
          <Stack
            css={{
              h: '$full',
              w: '$full',
              gap: '$6',
              flexWrap: 'wrap',
              '@lg': { flexWrap: 'nowrap' }
            }}
          >
            <Stack
              css={{
                rounded: '$lg',
                bgColor: '$neutral100',
                p: '$4',
                gap: '$3',
                w: '$full',
                alignItems: 'center'
              }}
            >
              <span className="h-42 w-42">
                <svg
                  width="42"
                  height="44"
                  viewBox="0 0 42 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="1"
                    width="40"
                    height="42"
                    rx="8"
                    fill="white"
                  />
                  <rect
                    x="1"
                    y="1"
                    width="40"
                    height="42"
                    rx="8"
                    stroke="#EAECF0"
                  />
                  <path
                    d="M15.167 20.3333V25.3426C15.167 25.6418 15.167 25.7913 15.2125 25.9234C15.2528 26.0401 15.3185 26.1465 15.405 26.2347C15.5027 26.3345 15.6365 26.4014 15.904 26.5352L20.404 28.7852C20.6227 28.8945 20.732 28.9492 20.8467 28.9707C20.9482 28.9897 21.0524 28.9897 21.154 28.9707C21.2687 28.9492 21.378 28.8945 21.5966 28.7852L26.0966 26.5352C26.3642 26.4014 26.4979 26.3345 26.5957 26.2347C26.6821 26.1465 26.7478 26.0401 26.7881 25.9234C26.8337 25.7913 26.8337 25.6418 26.8337 25.3426V20.3333M12.667 19.0833L20.7022 15.0657C20.8115 15.0111 20.8662 14.9838 20.9235 14.973C20.9743 14.9635 21.0264 14.9635 21.0772 14.973C21.1345 14.9838 21.1891 15.0111 21.2985 15.0657L29.3337 19.0833L21.2985 23.1009C21.1891 23.1556 21.1345 23.1829 21.0772 23.1937C21.0264 23.2032 20.9743 23.2032 20.9235 23.1937C20.8662 23.1829 20.8115 23.1556 20.7022 23.1009L12.667 19.0833Z"
                    stroke="#475467"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <h2 className="font-bold text-lg m-0 text-[rgba(0,0,0,0.85)]">
                {product?.name}
              </h2>
            </Stack>
          </Stack>
          <ResumeManyDiscountForm
            onCreate={() => window.location.reload()}
            rulesToCancel={discounts.map(d => d.id) || []}
            operator="=="
            timeRule={invoiceDueCreateData}
            productRule={productCreateData}
          />
        </Stack>
      </Stack>
    </Card>
  );
};

export const CreateProductPlanDealRule = () => {
  const { id } = useParams();
  const [mode, setMode] = useState<'create' | 'list'>('list');
  const [resourceType, setResType] = useState<'product_id' | 'invoice_due'>(
    'product_id'
  );

  const { tableQueryResult } = useTable<IProduct, HttpError>({
    resource: 'products',

    pagination: {
      pageSize: 5
    },

    filters: {
      permanent: [{ field: 'id', operator: 'eq', value: id }]
    }
  });

  const currentProduct = (tableQueryResult?.data?.data || []).find(
    product => product.id === id
  );

  const { tableQueryResult: discountResults, setFilters: setDiscountFIlters } =
    useTable<DiscountCampaign>({
      resource: 'discount_campaigns',

      pagination: {
        pageSize: 100
      },

      filters: {
        permanent: [
          {
            field: 'filter[rules][resource_type]',
            operator: 'eq',
            value: 'product_id'
          },
          {
            field: 'filter[rules][operator]',
            operator: 'eq',
            value: '=='
          },
          {
            field: 'filter[kind]',
            operator: 'eq',
            value: 'payment_plan_deal'
          },
          {
            field: 'filter[status]',
            operator: 'eq',
            value: 'active'
          },
          {
            field: 'filter[rules][value]',
            operator: 'eq',
            value: currentProduct?.id
          }
        ]
      }
    });

  const isLoading = tableQueryResult?.isLoading || discountResults?.isLoading;
  const originalDiscounts = useMemo(
    () => discountResults?.data?.data || [],
    [discountResults?.data?.data]
  );

  const discounts = originalDiscounts;

  const showProductForm =
    !isLoading && (discounts.length === 0 || mode === 'create');

  useEffect(() => {
    setDiscountFIlters([
      {
        field: 'filter[rules][value]',
        operator: 'eq',
        value: [currentProduct?.id]
      }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProduct]);

  return (
    <ShowLayout>
      <PageHeader
        title={discounts.length > 0 ? 'Regra vigente' : 'Criação de regra'}
        icon={DealIconComponent}
        meta={
          <Flex>
            <Tag>{currentProduct?.name}</Tag>
            <Tag color="blue">Essa regra só é aplicada a este produto</Tag>
          </Flex>
        }
      />
      <Card>
        <SetDiscountRuleType
          onChange={setResType}
          defaultValue={resourceType}
        />

        <Stack flow="column" className="mt-4">
          {showProductForm && currentProduct ? (
            <CreateManyProductDealForm
              discounts={discounts}
              product={currentProduct}
              resourceType={resourceType}
            />
          ) : (
            <ProductRuleList
              resourceType={resourceType}
              onCreate={() => setMode('create')}
              product={currentProduct!}
              discounts={discounts}
            />
          )}
        </Stack>
      </Card>
    </ShowLayout>
  );
};

const ProductRuleList = ({
  product,
  discounts,
  onCreate,
  resourceType
}: {
  product: IProduct;
  discounts: DiscountCampaign[];
  onCreate: () => void;
  resourceType: 'product_id' | 'invoice_due';
}) => {
  return (
    <Stack flow="column" css={{ w: '$full', h: '$full' }}>
      <Stack
        css={{
          d: 'flex',
          justifyContent: 'space-between',
          gap: '$10',
          w: '$full',
          h: '$full'
        }}
      >
        <RenderManyDiscounts
          discounts={discounts}
          resource_type={resourceType}
          hideException
        />
        <Stack flow="column" css={{ w: '$full', maxW: 400, gap: '$5' }}>
          <Stack
            css={{
              h: '$fit-content',
              w: '$full',
              gap: '$6',
              flexWrap: 'wrap',
              '@lg': { flexWrap: 'nowrap' }
            }}
          >
            <Stack
              css={{
                rounded: '$lg',
                bgColor: '$neutral100',
                p: '$4',
                gap: '$3',
                w: '$full',
                alignItems: 'center'
              }}
            >
              <span className="h-42 w-42">
                <svg
                  width="42"
                  height="44"
                  viewBox="0 0 42 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="1"
                    width="40"
                    height="42"
                    rx="8"
                    fill="white"
                  />
                  <rect
                    x="1"
                    y="1"
                    width="40"
                    height="42"
                    rx="8"
                    stroke="#EAECF0"
                  />
                  <path
                    d="M15.167 20.3333V25.3426C15.167 25.6418 15.167 25.7913 15.2125 25.9234C15.2528 26.0401 15.3185 26.1465 15.405 26.2347C15.5027 26.3345 15.6365 26.4014 15.904 26.5352L20.404 28.7852C20.6227 28.8945 20.732 28.9492 20.8467 28.9707C20.9482 28.9897 21.0524 28.9897 21.154 28.9707C21.2687 28.9492 21.378 28.8945 21.5966 28.7852L26.0966 26.5352C26.3642 26.4014 26.4979 26.3345 26.5957 26.2347C26.6821 26.1465 26.7478 26.0401 26.7881 25.9234C26.8337 25.7913 26.8337 25.6418 26.8337 25.3426V20.3333M12.667 19.0833L20.7022 15.0657C20.8115 15.0111 20.8662 14.9838 20.9235 14.973C20.9743 14.9635 21.0264 14.9635 21.0772 14.973C21.1345 14.9838 21.1891 15.0111 21.2985 15.0657L29.3337 19.0833L21.2985 23.1009C21.1891 23.1556 21.1345 23.1829 21.0772 23.1937C21.0264 23.2032 20.9743 23.2032 20.9235 23.1937C20.8662 23.1829 20.8115 23.1556 20.7022 23.1009L12.667 19.0833Z"
                    stroke="#475467"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <h2 className="font-bold text-lg m-0 text-[rgba(0,0,0,0.85)]">
                {product?.name}
              </h2>
            </Stack>
          </Stack>
          <ResumeManyDiscount discounts={discounts} onCreate={onCreate} />
        </Stack>
      </Stack>
    </Stack>
  );
};
